<template>
  <div class="award">
    <div class="xr-mingxi">
      <mu-appbar class="xr-head" title="我的奖金">
        <mu-icon-button v-on:click="GoHistory" icon=":fa fa-angle-left" slot="left"/>
        <router-link  slot="right" to="/salesman/awardstream">
            <p>明细</p>
        </router-link>
      </mu-appbar>
    </div>
    <div class="total" v-if="!loaded" :style="{  backgroundImage:'url('+siteConfig.MobileBgImage+')' }">
      <p class="title">奖金总额</p>
      <p class="money">{{awardInfo.totalAward.toFixed(2)}}</p>
    </div>
    <div class="sub-nav" v-if="!loaded">
      <mu-list>
        <router-link to="/salesman/awardstream?type=2">
          <mu-list-item title="推荐奖金">
            <mu-icon slot="left" value=":fa fa-money7"/>
            <p>{{awardInfo.zsAward.toFixed(2)}}</p>
            <mu-icon slot="right" value=":fa fa-angle-right"/>
          </mu-list-item>
        </router-link>
        <mu-divider shallowInset/>
        <router-link to="/salesman/awardstream?type=1">
          <mu-list-item title="零售奖金">
            <mu-icon slot="left" value=":fa fa-money4"/>
            <p>{{awardInfo.lsAward.toFixed(2)}}</p>
            <mu-icon slot="right" value=":fa fa-angle-right"/>
          </mu-list-item>
        </router-link>
        <mu-divider shallowInset/>
        <router-link to="/salesman/awardstream?type=3">
          <mu-list-item title="批发奖金">
            <mu-icon slot="left" value=":fa fa-transfer"/>
            <p>{{awardInfo.pfAward.toFixed(2)}}</p>
            <mu-icon slot="right" value=":fa fa-angle-right"/>
          </mu-list-item>
        </router-link>
        <mu-divider shallowInset/>
        <router-link to="/salesman/awardstream?type=4">
          <mu-list-item title="分红奖金">
            <mu-icon slot="left" value=":fa fa-money"/>
            <p>{{awardInfo.fhAward.toFixed(2)}}</p>
            <mu-icon slot="right" value=":fa fa-angle-right"/>
          </mu-list-item>
        </router-link>
      </mu-list>
    </div>
    <XR-toast ref="XRtoast"></XR-toast>
  </div>
</template>

<script>
import {ErrorCode} from '../../util/errorcode'
export default {
  data() {
    return {
      loaded : true,
      awardInfo :{
        totalAward:0,
        lsAward:0,
        pfAward:0,
        zsAward:0,
        fhAward:0
      },
      siteConfig:{ MobileBgImage: '' }
    };
  },
  mounted :function(){
    this.$postBase(
      this.MOBILE_URL + "/Oauth2/WeChat/wechat.ashx"
      ).then(function(res) {
      if(!res.IsSuccess){
          //ths.$refs.XRtoast.failed(res.Msg, true)
      }else{
          wx.config({
              debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
              appId: res.Data.AppId, // 必填，公众号的唯一标识
              timestamp: res.Data.TimeStamp, // 必填，生成签名的时间戳
              nonceStr: res.Data.NonceStr, // 必填，生成签名的随机串
              signature: res.Data.Sign, // 必填，签名，见附录1
              jsApiList: [] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
          });
          wx.ready(function () {
              WeixinJSBridge.call('hideOptionMenu');
          });
      }
    });
    this.$refs.XRtoast.load()
    this.getSiteInfo()
    this.getAwardInfo()
  },
  methods: {
    GoHistory(){
      this.$router.goBack()
    },
    getSiteInfo: function () {    
      const ths = this;
      this.$post('/Shop/SiteConfigServer/GetSiteConfig')
        .then(function (res) {
          if(res.IsSuccess){
            ths.siteConfig = res.Data
          }         
        })
        .catch(function (err) {
          console.log(err)
        })    
    },    
    getAwardInfo: function() {
      var ths = this;   
      ths.$post(
        "/Salesman/SalesmanServer/GetMyAwardTotal"
      ).then(function(res) {
        if(!res.IsSuccess){
          if(res.TypeId == ErrorCode.SessionMissing){
            ths.$router.push("/Login")
          }
        }else{          
          ths.awardInfo = res.Data;
          ths.loaded = false
          ths.$refs.XRtoast.hide()
        }
      });
    }
  }
};
</script>
<style>
.award .total{
  padding: 20px 20px;
  overflow: hidden;
  background: url(/static/us-top-bg.png);
  background-size: 100% 100%;
}
.award .title{
  line-height: 24px;
  font-size: 14px;
  color: white;
}
.award .money{
  font-size: 46px;
  color:red;
  line-height: 42px;
  padding: 10px 0 10px;
  letter-spacing: -1px;
  color: white;
}
.award .sub-nav{
  background: white;
  margin-top: 10px;
}
.award .show-right .mu-item-content{
  display: flex;
}
.award .show-right .mu-item-title-row{
  width: 100%;
}
.award .show-right .mu-item-content p{
  color:#ff0000;
  font-weight:bold;
}
.award .xr-mingxi .mu-appbar.fixed{  
  padding:0;
  position: fixed;
  top:0;
  left: 0;
}
.award .xr-mingxi .mu-appbar-title {
  font-size: 16px;
}
.award .xr-mingxi .title .mu-icon-button {
  position: absolute;
  left: 0;
  top: 0;
  color:white;
}
.award .xr-mingxi .title .title-text {
  margin: 0;
  line-height: 48px;
}
.award .xr-mingxi .right{
  margin: 0 8px;
  font-size: 16px
}
.award .xr-mingxi .right a{
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/pages/salesman/myaward.vue